import React from 'react';
import styled from 'styled-components';
import CustomLink from '../../../components/CustomLink';
import CustomPhoneNumber from '../../../components/CustomPhoneNumber';


const StyledWrapper = styled.div`
  display: grid;
  grid-template-rows: auto auto auto;
  z-index: 2;
  padding-left: 5%;
  
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.small}) {
    padding-left: 10%;
  }
  
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}) {
    padding-left: 15%;
  }
  
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.large}) {
    padding-left: 2%;
  }
  
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.extraLarge}) {
    padding-left: 11%;
  }
`;

// 'word-spacing: 100vw' allows us to break line every new word.
const Names = styled.span`
  color: ${({ theme }) => theme.colors.blue};
  font-weight: bold;
  font-size: 1.5em;
  line-height: normal;
  text-transform: uppercase;
  margin-bottom: 16px;
  word-spacing: 100vw;
`;

const Information = styled.div`
  color: ${({ theme }) => theme.colors.lightGray};
  font-weight: 700;
  text-transform: lowercase;
  margin-bottom: 4px;
`;

const StyledPhoneNumber = styled(CustomPhoneNumber)`
  font-weight: bold;
  padding-top: 5px;
`;

const MailLink = styled(CustomLink)`
  margin-bottom: 6px;
`;

interface FounderProps {
  name: string,
  position: string,
  job: string,
  email: string,
  phoneNumber: string,
}

const FounderContact = ({
  name, position, job, email, phoneNumber,
}: FounderProps) => (
  <StyledWrapper>
    <Names>
      {name}
    </Names>
    <Information>
      <div>
        {position}
      </div>
      <div>
        {job}
      </div>
    </Information>
    <div>
      <MailLink
        href={`mailto:${email}`}
      >
        {email}
      </MailLink>
      <StyledPhoneNumber
        phoneNumber={phoneNumber}
      >
        {phoneNumber}
      </StyledPhoneNumber>
    </div>
  </StyledWrapper>
);

export default FounderContact;
